import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { Dropdown } from 'react-bootstrap';


type Option = {
  label: string,
  onClick: () => void,
}

export const RepToolDropdown = ({
  options,
  disabled,
  toggleComponent,
  className
}: {
  options: Option[],
  disabled?: boolean,
  toggleComponent?: React.ReactNode,
  className?: string,
}) => {
  return (
    <Dropdown>
      <Dropdown.Toggle className={className} disabled={disabled} variant="outline-light">
        {toggleComponent || <FontAwesomeIcon className='mr-2' icon={faPen} />}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options.map(option => (
          <Dropdown.Item key={option.label} onClick={option.onClick}>{option.label}</Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}